"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePage = exports.useTotalPages = exports.useNext = exports.usePrev = exports.setData = exports.setPaginationData = exports.paginationSlice = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    appHashUrl: true,
    activePage: 1,
    totalPages: 999,
    prev: null,
    next: 'Next',
};
exports.paginationSlice = toolkit_1.createSlice({
    name: 'pagination',
    initialState: initialState,
    reducers: {
        setData: function (state, action) {
            state.totalPages = action.payload.totalPages;
            state.activePage = action.payload.activePage;
            state.prev = state.activePage === 1 ? null : 'Prev';
            state.next = state.activePage === state.totalPages ? null : 'Next';
        },
    },
});
var setPaginationData = function (paginationData) {
    return function (dispatch) {
        dispatch(exports.setData(paginationData));
    };
};
exports.setPaginationData = setPaginationData;
exports.setData = exports.paginationSlice.actions.setData;
var usePrev = function (state) { return state.pagination.prev; };
exports.usePrev = usePrev;
var useNext = function (state) { return state.pagination.next; };
exports.useNext = useNext;
var useTotalPages = function (state) { return state.pagination.totalPages; };
exports.useTotalPages = useTotalPages;
var usePage = function (state) { return state.pagination.activePage; };
exports.usePage = usePage;
exports.default = exports.paginationSlice.reducer;
